import posthog from "posthog-js";
import FullStory from "react-fullstory";
import { BrowserRouter as Router } from "react-router-dom";

import Authentication from "@/components/authentication";
import { AppProviders } from "@/providers/AppProviders";
import { AppRoutes } from "@/routes/AppRoutes";
import { isPublicRoute } from "@/utils/publicRoutes";

// Initialize PostHog
const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";
if (POSTHOG_KEY && window.location.hostname !== "localhost") {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: false,
    capture_pageleave: false,
  });
}

const App = () => {
  return (
    <Router>
      <FullStory org={"14DYPF"} />
      <Authentication>
        {(authState, location) => {
          if (isPublicRoute(location.pathname)) {
            return <AppRoutes authState={authState} location={location} />;
          }

          return (
            <AppProviders isAuthenticated={authState.authenticated}>
              <AppRoutes authState={authState} location={location} />
            </AppProviders>
          );
        }}
      </Authentication>
    </Router>
  );
};

export default App;
